import React, { useEffect, useState, useCallback } from 'react'
import { useEsri } from '../hooks'

import styles from './MeasurementTool.module.css'

const esriReqs = ['esri/widgets/Measurement']

const MeasurementTool = ({ map, view, position }) => {
  const [ready, { Measurement }] = useEsri(esriReqs)
  const [active, setActive] = useState(false)
  const [widget, setWidget] = useState(null)

  useEffect(() => {
    if (ready && map && view) {
      const tool = new Measurement({
        view,
        linearUnit: 'miles',
      })
      view.ui.add(tool, position || 'top-right')
      setWidget(tool)
    }
  }, [ready, Measurement, map, view, position])

  const startMeasuring = useCallback(() => {
    if (widget !== null) {
      widget.activeTool = 'distance'
      setActive(true)
    }
  }, [widget])

  const endMeasuring = useCallback(() => {
    if (widget !== null) {
      widget.clear()
      setActive(false)
    }
  }, [widget])

  return (
    <div className={`${styles.toolbar} esri-component esri-widget`}>
      {active ? (
        <button
          onClick={endMeasuring}
          className="esri-widget--button esri-interactive esri-icon-trash"
          title="Clear Measurements"
        ></button>
      ) : (
        <button
          onClick={startMeasuring}
          className="esri-widget--button esri-interactive esri-icon-measure-line"
          title="Distance Measurement Tool"
        ></button>
      )}
    </div>
  )
}

export default MeasurementTool
